import { useAuth } from 'src/state/auth';

export const useCanManageContent = () => {
  const { isPlatformAdmin } = useAuth();

  return Boolean(isPlatformAdmin);
};
